function toIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** First and last calendar day of the current month, as 'YYYY-MM-DD' strings. */
export function getCurrentMonthRange(): { dateFrom: string; dateTo: string } {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return { dateFrom: toIsoDate(firstDay), dateTo: toIsoDate(lastDay) };
}
